import styled from 'styled-components';

export const NoWrapStyled = styled.div`
  white-space: nowrap;
`;
